import { render, staticRenderFns } from "./QuestionnaireCollapse.vue?vue&type=template&id=70879770&scoped=true"
import script from "./QuestionnaireCollapse.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCollapse.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireCollapse.vue?vue&type=style&index=0&id=70879770&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70879770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70879770')) {
      api.createRecord('70879770', component.options)
    } else {
      api.reload('70879770', component.options)
    }
    module.hot.accept("./QuestionnaireCollapse.vue?vue&type=template&id=70879770&scoped=true", function () {
      api.rerender('70879770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/service-satisfaction-questionnaire/components/QuestionnaireCollapse.vue"
export default component.exports